import React, { FC } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { CarouselGalleryProps } from './HeroGallery.types';
import { StyledHeroGallery } from './HeroGallery.styles';
import { Image } from '@marriott/mi-ui-library';

export const HeroGalleryConfig = {
  emptyLabel: 'LoveTravelsHeroGallery',
  isEmpty: () => true,
};

export const HeroGalleryComp: FC<CarouselGalleryProps> = (props: CarouselGalleryProps) => {
  const { model } = props;
  const { heroTitle, heroCopy, assets = [], heroLogo } = model;

  // Safely extract authored data from the model
  const componentId = model?.componentId || 'hero-gallery';
  const carouselItems = Array.isArray(model?.dynamicMedia) ? model.dynamicMedia : [];

  // If empty, return null (EditableComponent will use emptyLabel)
  if (!carouselItems.length) {
    return null;
  }

  return (
    <StyledHeroGallery id={`${componentId}__wrapper`} data-testid="hero-gallery">
      <div
        id={`${componentId}__slides`}
        className="carousel slide carousel-fade lt-header-overlay"
        data-bs-ride="carousel"
        data-bs-interval="3000"
      >
        <div className="carousel-inner">
          {carouselItems.map((item, index) => {
            const altText = item?.altText || 'Hero image';
            const renditions = item?.renditions;
            const dynamic = item?.dynamic;
            const defaultImageURL = item?.assetPath;

            return (
              <div key={`carousel-item_${index}`} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                <Image
                  altText={altText}
                  renditions={renditions}
                  dynamic={dynamic}
                  defaultImageURL={defaultImageURL}
                  loading="lazy"
                  customClass="image-hero d-block"
                />

                {/* Mobile credit line */}
                {assets[index]?.imageCreditLine ? (
                  <div className="container credit-line--mobile">
                    <div className="credit-line-wrapper">
                      <h5 className="credit-line">{assets[index].imageCreditLine}</h5>
                    </div>
                  </div>
                ) : null}

                {/* Desktop credit line */}
                {assets[index]?.imageCreditLine ? (
                  <div className="credit-line-wrapper desktop">
                    <h5 className="credit-line">{assets[index].imageCreditLine}</h5>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
        <div className="container">
          <div className="content-wrapper">
            <div className="logo-wrapper">
              {heroLogo?.assetPath && <img src={heroLogo?.assetPath} alt={heroLogo?.altText} />}
            </div>
            <div className="title-wrapper">
              <h1 className="lt-title-1">{heroTitle}</h1>
            </div>
            <div className="copy-wrapper">
              <p>{heroCopy}</p>
            </div>
          </div>
        </div>
      </div>
    </StyledHeroGallery>
  );
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const HeroGallery = (props: CarouselGalleryProps) => {
  return (
    <div data-testid="hero-gallery" data-component-name="o-prearrival-lovetravels-hero-gallery">
      <EditableComponent config={HeroGalleryConfig} {...props}>
        <HeroGalleryComp {...props} />
      </EditableComponent>
    </div>
  );
};
